import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let location_id = useDataValue({
    context: 'location',
    path: 'organization_id',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'selected',
    path: 'location_id',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    change(location_id)
  }
}
